import { useQuery } from '@tanstack/react-query';
import { getSupportContacts } from '@/lib/api';

export default function Footer({ className }: { className?: string }) {
  const { data: supportContacts } = useQuery({
    queryKey: ['support-contacts'],
    queryFn: getSupportContacts,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const emails = supportContacts?.emails ?? [];
  const phones = supportContacts?.phones ?? [];
  const hasContacts = emails.length > 0 || phones.length > 0;

  return (
    <footer
      className={`border-t bg-card text-center py-3 px-4 text-xs text-muted-foreground shrink-0${className ? ` ${className}` : ""}`}
    >
      {hasContacts && (
        <p>
          For Support:{' '}
          {emails.length > 0 && (
            <span className="inline-flex items-center gap-1 flex-wrap justify-center">
              📧{' '}
              {emails.map((email, i) => (
                <span key={email}>
                  <a
                    href={`mailto:${email}`}
                    className="text-primary hover:underline"
                  >
                    {email}
                  </a>
                  {i < emails.length - 1 ? ', ' : ''}
                </span>
              ))}
            </span>
          )}
          {emails.length > 0 && phones.length > 0 && ' | '}
          {phones.length > 0 && (
            <span className="inline-flex items-center gap-1 flex-wrap justify-center">
              📞{' '}
              {phones.map((phone, i) => (
                <span key={phone}>
                  {phone}
                  {i < phones.length - 1 ? ', ' : ''}
                </span>
              ))}
            </span>
          )}
        </p>
      )}
      <p className="mt-0.5">
        © {new Date().getFullYear()} - Talent Hub. NNPC Ltd.
      </p>
    </footer>
  );
}
